const Global = {
  color: {
    body: "#2A2A2A",
    primary: "#5C7D92",
    secondary: "#889AAA",
    tertiary: "#B1BAC5",
    light: "#D9DCE1",
    dark: "#444444",
    accent: "#E42058",
    secondAccent: "#5973e8",
    background: "#F5F5F5",
    lightBackground: "#FFF",
    disabled: "#CCC",
    protect: "#42ad2e",
    absence: "#696E77",
    destruct: "#E52727",
    medium: "#EA8A35"
  },
  font: {
    title: "Ubuntu",
    body: "Open Sans",
    size: {
      body: "1rem",
      caption: "0.8rem",
      header: "1.5rem"
    },
    weight: {
      body: 400,
      caption: 300,
      header: 500
    }
  },
  height: {
    navigation: "3.5rem"
  }
};
export default Global;
